/**
 * Wrapper for every grouped settings section (plan 6.D–6.H):
 * mobile back → heading → `section.eb-full-settings-card.grouped-settings` → groups → settings note.
 */

import React from "react";
import Icon from "../../ui/Icon";
import { useBuilder } from "../../state/builderContext";
import { COPY, SECTIONS } from "../../state/constants";

const SettingsView = ({ icon, title, text, children, note = true }) => {
  const { goToSection } = useBuilder();
  return (
    <div className="eb-settings-view">
      <button type="button" className="eb-mobile-back" onClick={() => goToSection(SECTIONS.QUICK)}>
        <Icon name="arrow-left" size={15} /> {COPY.sections[SECTIONS.QUICK]}
      </button>
      <div className="eb-settings-heading">
        <span className="eb-large-setting-icon">
          <Icon name={icon} size={19} />
        </span>
        <div>
          <h1>{title}</h1>
          <p>{text}</p>
        </div>
      </div>
      <section className="eb-full-settings-card grouped-settings">
        {children}
        {note ? (
          <div className="eb-settings-note">
            <Icon name="check" size={17} />
            <span>{COPY.note}</span>
          </div>
        ) : null}
      </section>
    </div>
  );
};

export default SettingsView;
